import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CadastroReservaMunicipio } from '../../../shared/models/response/cadastro-reserva-municipio.model';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { BrButton } from '@govbr-ds/webcomponents-angular/standalone';
import { CommonModule } from '@angular/common';
import { CadastroReservaMunicipioService } from '../../../shared/services/cadastro-reserva-municipio.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { AlertService } from '../../../shared/services/alert.service';
import { Municipio } from '../../../shared/models/response/localidade.model';
import { Usuario } from '../../../shared/model/usuario.model';

import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

@Component({
  selector: 'app-confirmar-cadastro-reserva',
  imports: [CommonModule, ReactiveFormsModule, BrButton],
  templateUrl: './confirmar-cadastro-reserva.component.html',
  styleUrl: './confirmar-cadastro-reserva.component.scss',
})
export class ConfirmarCadastroReservaComponent implements OnInit {
  @Input() modalRef!: NgbModalRef;
  @Input() usuario!: Usuario;
  @Input() cadastrosReservaMunicipio: CadastroReservaMunicipio[] = [];
  @Input() isPeriodoVigente: boolean = false;

  municipio!: Municipio;

  private readonly formBuilder = inject(FormBuilder);
  private readonly cadastroReservaMunicipioService = inject(
    CadastroReservaMunicipioService,
  );
  private readonly loadingService = inject(LoadingService);
  private readonly alertService = inject(AlertService);
  private readonly cdr = inject(ChangeDetectorRef);

  form!: FormGroup;
  submitting = false;

  get cadastrosFormArray(): FormArray {
    return this.form.get('cadastrosReservaMunicipio') as FormArray;
  }

  get isConfirmado(): boolean {
    return (
      this.cadastrosReservaMunicipio.filter((c) => c.dtConfirmacao != null)
        .length > 0
    );
  }

  getDataConfirmacaoFormatada(date: Date | null | undefined = new Date()): string {
    if (!date) date = new Date();
    return format(date, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
  }

  ngOnInit(): void {
    this.municipio = this.cadastrosReservaMunicipio[0]?.municipio!;
    this.form = this.formBuilder.group({
      cadastrosReservaMunicipio: this.formBuilder.array(
        this.cadastrosReservaMunicipio.map((cadastro) => {
          return this.formBuilder.group({
            id: [cadastro.id],
            tipoEquipe: [cadastro.tipoEquipe],
            confirmacao: [
              {
                value: cadastro.stConfirmado,
                disabled:
                  !this.isPeriodoVigente || cadastro.dtConfirmacao != null,
              },
              [Validators.required],
            ],
          });
        }),
      ),
      termoAdesao: [false, [Validators.requiredTrue]],
    });
  }

  confirmar(): void {
    if (this.form.invalid || this.submitting) {
      return;
    }

    this.alertService.confirm(
      'Atenção: esta ação é definitiva. Após a confirmação não poderá ser editada. Caso necessite de alterações, será necessário abrir um recurso dentro do prazo previsto no edital. Deseja confirmar?',
      () => {
        const request = this.cadastrosFormArray.controls.map((control) => {
          const valorConfirmacao = control.get('confirmacao')?.value;

          return {
            cadastroReservaMunicipioId: control.get('id')?.value,
            confirmado:
              valorConfirmacao === true ||
              valorConfirmacao === 'true' ||
              valorConfirmacao === 'S',
          };
        });

        this.submitting = true;
        this.loadingService.open();

        this.cadastroReservaMunicipioService
          .confirmarCadastroReservaMunicipio(request)
          .subscribe({
            next: (response) => {
              this.loadingService.close();
              this.submitting = false;
              this.alertService.success(
                'Cadastro de reserva confirmado com sucesso.',
              );
              this.cdr.detectChanges();
              this.modalRef.close(response);
            },
            error: (error) => {
              this.loadingService.close();
              this.submitting = false;
              if (error?.detail) {
                this.alertService.error(error.detail);
              } else {
                this.alertService.error(
                  'Erro ao confirmar cadastro de reserva.',
                );
              }
              this.cdr.detectChanges();
            },
          });
      },
    );
  }
}
